<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'ADD'" @close="closeModal" :title="$t('AddContact').toUpperCase()">
            <contact-modal @cancel="closeModal" @save="closeModal('getData')"></contact-modal>
        </modal>
        <modal :showDialog="activeModal === 'EDIT_CONTACT'" @close="closeModal" :title="$t('EditContact').toUpperCase()">
            <contact-modal :contactObj="activeContact" @cancel="closeModal" @save="closeModal('getData')"></contact-modal>
        </modal>
        <modal :showDialog="activeModal === 'EDIT_USER'" @close="closeModal" :title="'EDIT USER'">
            <user-modal :userObj="activeContact" @cancel="closeModal" @save="closeModal('getData')"></user-modal>
        </modal>
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="activeContact != null ? (activeContact.isUser ? 'DELETE USER' : $t('DeleteContact').toUpperCase()) : ''">
            <delete-confirm @cancel="closeModal" @confirm="deleteContact" :text="deleteText"></delete-confirm>
        </modal>
		<div>
			<div class="max-grid">
				<ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="contacts" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" >
					<e-columns>
                        <e-column field='systemsGroup' :headerText="$t('Group')" textAlign='Left' :filter="filterCheckBox" :customAttributes="customAttributes"></e-column>
                        <e-column field='systems' :headerText="$t('Systems')" textAlign='Left' :template="systemAccessTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field='fullName' :template="TextTemplate" :headerText="$t('FullName')" textAlign='Left' :customAttributes="customAttributes"></e-column>
						<e-column field='email' :headerText="$t('Email')" textAlign='Left' :template="TextTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field='phoneNumber' :headerText="$t('PhoneNumber')" textAlign='Left' :customAttributes="customAttributes" :valueAccessor="valueAccessorPhoneNumber"></e-column>
						<e-column field='description' :headerText="$t('Description')" textAlign='Left' :customAttributes="customAttributes" :template="TextTemplate"></e-column>
						<e-column field='id' headerText="" width="100px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>
    </div>
</template>

<script>
import Button from '@/components/Button'
import { getAllContacts, deleteContact, deleteUser, getContactSystems } from '@api'

import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Modal from '../components/Modal.vue'
import ContactModal from '../components/Contacts/ContactModal.vue'
import UserModal from '../components/Users/UserModal.vue'
import DeleteConfirm from '../components/DeleteConfirm.vue'
import Vue from "vue";
import libphonenumber from 'google-libphonenumber';
import countriesDataJson from '@/assets/json/countries.json'
import EllipsisTextCellVue from '../components/Systems/EllipsisTextCell.vue';
import ProbablyOverflowingTextCell from '../components/Systems/ProbablyOverflowingTextCell';

export let context = null

export default {
    props: {
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    components: {
        Button,
        Modal,
        ContactModal,
        DeleteConfirm,
        UserModal,
    },
    data() {
        return {
            contacts: [],
            activeModal: 'NONE',
            activeContact: null,
            deleteText: '',
            phoneUtil: null,
            PNF: null,
            countriesData: null,

            pageSettings: { pageSize: 100, pageSizes: [10,25,50,100] },
            toolbar: [
                { text: this.$t('Contacts'), align: 'Left', id: 'table-title'},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},
                { text: this.$t('AddContact'), tooltipText: this.$t('AddContact'), prefixIcon: 'e-add', id: 'addContact', align: 'Right' },
                'Search'
            ],
            wrapSettings: { wrapMode: 'Header' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckBox: {
                type: 'CheckBox',
            },
            customAttributes : {class: 'customcss'},
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div v-if="!data.isUser" class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('EDIT')" :content="$t('Edit')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>
                                </div>
                                <div v-if="!data.isUser" class="" style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" :content="$t('Delete')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                            </div>

                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch(mode){
                                    case 'EDIT':
                                        this.data.isUser ? context.openModal(this.data, 'EDIT_USER') : context.openModal(this.data, 'EDIT_CONTACT')
                                        break;
                                    case 'DELETE':
                                        context.openModal(this.data, 'DELETE')
                                        break;
                                }
                            }
                        }
                    })
                }
            },
            systemAccessTemplate: function() {
                return {
                    template: {
                        extends: EllipsisTextCellVue,
                    }
                }
            },
            TextTemplate: function () {
				return {
					template: {
						extends: ProbablyOverflowingTextCell,
					},
				};
			},
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            let result = await getAllContacts();
            this.contacts = result
            this.$store.dispatch('set_loading', false)
        },
        async deleteContact() {
          if (this.activeContact.isUser) {
            await deleteUser(this.activeUser.id);
            this.getData();
            this.closeModal()
          } else {
            await deleteContact(this.activeContact.id);
            this.getData();
            this.closeModal()
          }
        },
        openModal(contact, mode) {
            this.activeContact = contact
            this.deleteText = this.$t('Delete') + ' ' + (this.activeContact != null ? this.activeContact.fullName : '');
            this.activeModal = mode
        },
        closeModal(mode){
            this.activeContact = null
            this.activeModal = 'NONE'
            if(mode == 'getData')
                this.getData()
        },

        toolbarClick: function(args) {
            switch(args.item.id){
                case 'addContact':
                    this.openModal(null, 'ADD')
                    break;
                case 'table-title':
                    this.getData();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function() {
            this.$refs.grid.autoFitColumns();
        },
        valueAccessorPhoneNumber: function(field, data1, column) {
          if (data1[field]) {

            var country = data1['country'];

            if (data1['country'] == 'Northern Ireland') {
              country = 'United Kingdom'
            }

            var code = this.countriesData.filter(x => x.name.common == country || x.name.official == country || x.altSpellings.includes(country))[0];

            if (code != undefined) {
              var number = this.phoneUtil.parseAndKeepRawInput(data1[field], code.cca2);
              var numberForm = this.phoneUtil.format(number, this.PNF.INTERNATIONAL)
              return numberForm
            }
          }

          return data1[field];
        }
    },
    mounted: async function () {
        this.phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        this.PNF = libphonenumber.PhoneNumberFormat;
        this.countriesData = countriesDataJson;

        await this.getData();

        context = this
    },
}
</script>

<style scoped>
    .table {
        border-top: none;
        border-left: none;
        border-right: none;
    }

    .table tbody{
        border-left: 1px solid #A3D4E0;
        border-right: 1px solid #A3D4E0;
    }
    .e-grid .e-headercell.customcss{
        padding:0 5px 0 5px;
    }

    .e-grid .e-headercell .e-headercelldiv{
        padding-right:5px;
    }
    .e-gridchkbox.customcss .e-checkbox-wrapper{
        vertical-align: middle;
    }
</style>

<style>
    .tippy-tooltip.customTheme-theme {
      background-color: #346F8B;
    }

    .tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
      border-left: 8px solid #346F8B;
    }
</style>



// WEBPACK FOOTER //
// src/views/Contacts.vue